// components/Footer.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/logo.png';
import {
  FiMessageCircle,
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiTwitter,
  FiYoutube
} from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const closeMobileMenu = () => setIsMobileMenuOpen(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    closeMobileMenu();
  };

  const handleDemoClick = (e) => {
    e.preventDefault();
    window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
    closeMobileMenu();
  };

  const socialLinks = [
    {
      name: 'Facebook',
      icon: <FiFacebook />,
      url: 'https://facebook.com/your-page',
      color: '#1877f2',
      hoverColor: '#1877f2'
    },
    {
      name: 'Instagram',
      icon: <FiInstagram />,
      url: 'https://instagram.com/your-page',
      color: '#e4405f',
      hoverColor: '#e4405f'
    },
    {
      name: 'LinkedIn',
      icon: <FiLinkedin />,
      url: 'https://linkedin.com/company/your-company',
      color: '#0077b5',
      hoverColor: '#0077b5'
    },
    {
      name: 'YouTube',
      icon: <FiYoutube />,
      url: 'https://youtube.com/@your-channel',
      color: '#ff0000',
      hoverColor: '#ff0000'
    },
    {
      name: 'X (Twitter)',
      icon: <FiTwitter />,
      url: 'https://twitter.com/your-handle',
      color: '#1da1f2',
      hoverColor: '#1da1f2'
    },
    {
      name: 'WhatsApp',
      icon: <FiMessageCircle />,
      url: 'https://wa.me/923000000000',
      color: '#25D366',
      hoverColor: '#25D366'
    }
  ];

  const handleClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>
          <p>Affordable e-commerce websites for small businesses.</p>
          <div className="social-links-container">
            <div className="social-links-grid">
              {socialLinks.map((social, index) => (
                <div
                  key={index}
                  className="social-link-item"
                  onClick={() => handleClick(social.url)}
                  style={{ '--social-color': social.color, '--social-hover': social.hoverColor }}
                >
                  <div className="social-icon-wrapper">
                    {social.icon}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="https://demo-site.creativepulse.pk" target='_blank'>Demo</Link></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div className="footer-section contact-section">
          <h4>Get in Touch</h4>
          <ul className="contact-list">
            <li><a href="mailto:hello@commex.pk" className="contact-link">hello@commex.pk</a></li>
            <li><a href="https://wa.me/923000000000" className="contact-link">WhatsApp: +92 XXX XXXXXXX</a></li>
            <li><Link to="/contact" className="get-in-touch-btn">Get in Touch</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Copyright © 2026 DotLocalhost. All Rights Reserved.</p>
        <p className="made-for-pakistan">Made for small businesses in Pakistan.</p>
      </div>
    </footer>
  );
};

export default Footer;